import { NgModule } from '@angular/core';
import { EmbedHtmlComponent } from './component/embed-html/embed-html.component';
import { StrPipe } from './pipe/str';
import { FormatDatePipe } from './pipe/format-date';
import { FormatDateService } from './service/format-date.service';
import { LazyLoadingService } from './service/lazy-loading';
import { JsonParsePipe } from './pipe/json-parse';
import { TimeDuration } from './pipe/time-duration';
import { Uncamel } from './pipe/uncamel';
import { TextLengthDirective } from './directive/text-length.directive';

@NgModule({
  declarations: [
    EmbedHtmlComponent,
    StrPipe,
    FormatDatePipe,
    JsonParsePipe,
    TimeDuration,
    Uncamel,
    TextLengthDirective,
  ],
  exports: [
    EmbedHtmlComponent,
    StrPipe,
    FormatDatePipe,
    JsonParsePipe,
    TimeDuration,
    Uncamel,
    TextLengthDirective,
  ],
  providers: [
    FormatDateService,
    LazyLoadingService
  ]
})
export class MiscModule {

}
